import { createContext, useContext, useEffect, useState, useCallback } from "react";

const dict = {
  fr: {
    // Navigation
    nav_home: "Accueil",
    nav_vehicles: "Véhicules",
    nav_how: "Comment ça marche",
    nav_about: "À propos",
    nav_contact: "Contact",
    nav_account: "Mon compte",
    nav_dashboard: "Tableau de bord",
    nav_my_bookings: "Mes réservations",
    nav_logout: "Déconnexion",

    // Home
    home_badge: "Location de véhicules en Afrique",
    home_title_1: "Réservez votre véhicule",
    home_title_2: "avant votre arrivée.",
    home_subtitle: "Comparez les offres de plusieurs agences locales et voyagez en toute sérénité sur votre continent.",
    home_search_destination: "Destination",
    home_search_city_placeholder: "Ville (ex : Pointe-Noire)",
    home_search_start: "Date d'arrivée",
    home_search_end: "Date de départ",
    home_search_type: "Type de service",
    home_search_no_driver: "Sans chauffeur",
    home_search_with_driver: "Avec chauffeur",
    home_search_rental_type: "Durée",
    rt_day: "Jour",
    rt_week: "Semaine",
    rt_month: "Mois",
    home_search_btn: "Rechercher",
    home_feat_verified: "Agences vérifiées",
    home_feat_verified_sub: "Partenaires fiables et validés",
    home_feat_early: "Réservez avant votre départ",
    home_feat_early_sub: "Gagnez du temps dès l'aéroport",
    home_feat_wa: "Assistance WhatsApp",
    home_feat_wa_sub: "Une équipe 7j/7",
    home_feat_pay: "Paiement sécurisé",
    home_feat_pay_sub: "Vos transactions protégées",
    home_fleet: "Notre flotte",
    home_available: "Véhicules disponibles",
    home_see_all: "Voir tous les véhicules",
    home_empty_fleet: "Aucun véhicule disponible pour le moment.",
    home_empty_fleet_sub: "Les agences partenaires ajouteront bientôt leurs véhicules.",
    home_network: "Nos partenaires",
    home_agencies_title: "Agences partenaires",
    home_empty_agencies: "Bientôt disponible : nos agences partenaires en Afrique.",
    home_cta_partner_badge: "Devenez partenaire",
    home_cta_partner_title: "Votre agence nous rejoint",
    home_cta_partner_sub: "Élargissez votre clientèle en Afrique. Publiez vos véhicules, gérez vos réservations et développez votre activité.",
    home_cta_partner_btn: "Rejoindre la plateforme",

    // Common
    per_day: "par jour",
    seats: "places",
    view: "Voir",
    book_now: "Réserver maintenant",
    login: "Se connecter",
    register: "Créer un compte",
    email: "Email",
    password: "Mot de passe",
    first_name: "Prénom",
    last_name: "Nom",
    phone: "Téléphone",
    country: "Pays",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    next: "Continuer",
    prev: "Précédent",
    loading: "Chargement…",
    verified_agency: "Agence vérifiée",
    available: "Disponible",

    // Vehicle card / detail
    vd_ideal_for: "Ce véhicule est idéal pour",
    vd_description: "Description du véhicule",
    vd_features: "Caractéristiques détaillées",
    vd_calendar: "Calendrier de disponibilité",
    vd_conditions: "Conditions de location",
    vd_about_agency: "À propos de l'agence",
    vd_deposit_note: "Acompte {p}% · Solde à la remise du véhicule",

    // Booking
    bk_step_details: "Vos informations",
    bk_step_docs: "Documents",
    bk_step_payment: "Paiement",
    bk_step_confirm: "Confirmation",
    bk_summary: "Récapitulatif",
    bk_arrival: "Arrivée",
    bk_departure: "Départ",
    bk_pickup: "Lieu de remise du véhicule",
    bk_flight: "Numéro de vol (optionnel)",
    bk_docs_hint: "Fournissez les URLs de vos documents.",
    bk_license: "Permis de conduire (URL)",
    bk_passport: "Passeport (URL)",
    bk_id: "Pièce d'identité (URL)",
    bk_pay_title: "Paiement",
    bk_pay_hint: "Paiement sécurisé.",
    bk_pay_card: "Carte bancaire",
    bk_pay_mobile: "Mobile Money — Orange, MTN, Wave (bientôt)",
    bk_pay_summary: "Vous payez l'acompte de {a} aujourd'hui. Le solde de {b} sera dû à la remise du véhicule.",
    bk_ready: "Prêt à confirmer",
    bk_ready_hint: "En cliquant sur \"Confirmer\", vous acceptez les conditions générales et payez l'acompte.",
    bk_confirm: "Confirmer la réservation",
    bk_days: "Jours",
    bk_driver: "Chauffeur",
    bk_yes: "Oui",
    bk_no: "Non",
    bk_subtotal: "Sous-total",
    bk_deposit: "Acompte",
    bk_balance: "Solde à la remise",

    // Confirmation
    cf_success_title: "Votre réservation est confirmée !",
    cf_success_sub: "Merci pour votre confiance. Un e-mail récapitulatif vous a été envoyé.",
    cf_ref: "Numéro de réservation",
    cf_download: "Télécharger le contrat",
    cf_whatsapp: "Contacter par WhatsApp",
    cf_signature: "Signature électronique",
    cf_clear_sig: "Effacer",
    cf_sign: "Signer le contrat",
    cf_signed_on: "Signé le",
    cf_pay_details: "Détails du paiement",
    cf_paid: "Acompte payé",

    // Footer
    ft_desc: "La plateforme premium de réservation de véhicules en Afrique. Fiable, moderne, sécurisée.",
    ft_navigation: "Navigation",
    ft_partners: "Partenaires",
    ft_become_partner: "Devenir agence partenaire",
    ft_agency_space: "Espace agence",
    ft_contact: "Contact",
    ft_rights: "Tous droits réservés.",
  },
  en: {
    // Navigation
    nav_home: "Home",
    nav_vehicles: "Vehicles",
    nav_how: "How it works",
    nav_about: "About",
    nav_contact: "Contact",
    nav_account: "My account",
    nav_dashboard: "Dashboard",
    nav_my_bookings: "My bookings",
    nav_logout: "Log out",

    // Home
    home_badge: "Vehicle rental in Africa",
    home_title_1: "Book your vehicle",
    home_title_2: "before you arrive.",
    home_subtitle: "Compare offers from local trusted agencies and travel with peace of mind across your continent.",
    home_search_destination: "Destination",
    home_search_city_placeholder: "City (e.g. Pointe-Noire)",
    home_search_start: "Pick-up date",
    home_search_end: "Return date",
    home_search_type: "Service type",
    home_search_no_driver: "Without driver",
    home_search_with_driver: "With driver",
    home_search_rental_type: "Duration",
    rt_day: "Day",
    rt_week: "Week",
    rt_month: "Month",
    home_search_btn: "Search",
    home_feat_verified: "Verified agencies",
    home_feat_verified_sub: "Trusted, validated partners",
    home_feat_early: "Book before you leave",
    home_feat_early_sub: "Save time upon arrival",
    home_feat_wa: "WhatsApp support",
    home_feat_wa_sub: "A team 7/7",
    home_feat_pay: "Secure payment",
    home_feat_pay_sub: "Your transactions are protected",
    home_fleet: "Our fleet",
    home_available: "Available vehicles",
    home_see_all: "See all vehicles",
    home_empty_fleet: "No vehicles available yet.",
    home_empty_fleet_sub: "Partner agencies will soon add their vehicles.",
    home_network: "Our partners",
    home_agencies_title: "Partner agencies",
    home_empty_agencies: "Coming soon: our partner agencies in Africa.",
    home_cta_partner_badge: "Become a partner",
    home_cta_partner_title: "Your agency joins us",
    home_cta_partner_sub: "Grow your customer base across Africa. List your vehicles, manage bookings, expand your business.",
    home_cta_partner_btn: "Join the platform",

    // Common
    per_day: "per day",
    seats: "seats",
    view: "View",
    book_now: "Book now",
    login: "Log in",
    register: "Create account",
    email: "Email",
    password: "Password",
    first_name: "First name",
    last_name: "Last name",
    phone: "Phone",
    country: "Country",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    next: "Continue",
    prev: "Back",
    loading: "Loading…",
    verified_agency: "Verified agency",
    available: "Available",

    // Vehicle detail
    vd_ideal_for: "This vehicle is ideal for",
    vd_description: "Vehicle description",
    vd_features: "Detailed features",
    vd_calendar: "Availability calendar",
    vd_conditions: "Rental conditions",
    vd_about_agency: "About the agency",
    vd_deposit_note: "Deposit {p}% · Balance due at pick-up",

    // Booking
    bk_step_details: "Your details",
    bk_step_docs: "Documents",
    bk_step_payment: "Payment",
    bk_step_confirm: "Confirmation",
    bk_summary: "Summary",
    bk_arrival: "Pick-up",
    bk_departure: "Return",
    bk_pickup: "Pick-up location",
    bk_flight: "Flight number (optional)",
    bk_docs_hint: "Provide URLs to your documents.",
    bk_license: "Driver's license (URL)",
    bk_passport: "Passport (URL)",
    bk_id: "ID card (URL)",
    bk_pay_title: "Payment",
    bk_pay_hint: "Secure payment.",
    bk_pay_card: "Credit card",
    bk_pay_mobile: "Mobile Money — Orange, MTN, Wave (soon)",
    bk_pay_summary: "You pay the deposit of {a} today. The balance of {b} will be due at pick-up.",
    bk_ready: "Ready to confirm",
    bk_ready_hint: "By clicking \"Confirm\", you accept the terms and pay the deposit.",
    bk_confirm: "Confirm booking",
    bk_days: "Days",
    bk_driver: "Driver",
    bk_yes: "Yes",
    bk_no: "No",
    bk_subtotal: "Subtotal",
    bk_deposit: "Deposit",
    bk_balance: "Balance at pick-up",

    // Confirmation
    cf_success_title: "Your booking is confirmed!",
    cf_success_sub: "Thank you. A summary has been sent to your email.",
    cf_ref: "Booking reference",
    cf_download: "Download contract",
    cf_whatsapp: "Contact us on WhatsApp",
    cf_signature: "Electronic signature",
    cf_clear_sig: "Clear",
    cf_sign: "Sign the contract",
    cf_signed_on: "Signed on",
    cf_pay_details: "Payment details",
    cf_paid: "Deposit paid",

    // Footer
    ft_desc: "The premium vehicle booking platform in Africa. Reliable, modern, secure.",
    ft_navigation: "Navigation",
    ft_partners: "Partners",
    ft_become_partner: "Become a partner agency",
    ft_agency_space: "Agency portal",
    ft_contact: "Contact",
    ft_rights: "All rights reserved.",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("mbk_lang") || "fr"; } catch { return "fr"; }
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("mbk_lang", l); } catch {}
  }, []);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const t = useCallback((key, vars = {}) => {
    const raw = (dict[lang] && dict[lang][key]) || (dict.fr && dict.fr[key]) || key;
    return raw.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
  }, [lang]);
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
